import type { ComponentType } from 'react';
import {
  BigIcon,
  PrioritisationIcon,
  BulletsIcon,
  ChoicesIcon,
  DeprecatedIcon,
  DocumentIcon,
  FreeTextIcon,
  GoogleSlidesIcon,
  HeadingIcon,
  ImageIcon,
  InstructionsIcon,
  MiroIcon,
  NumberIcon,
  OpenEndedIcon,
  PinOnImageIcon,
  PowerpointIcon,
  QfaIcon,
  QuizChoicesIcon,
  QuizLeaderboardIcon,
  QuizOpenIcon,
  QuoteIcon,
  RankingIcon,
  RatingIcon,
  ScalesIcon,
  VideoIcon,
  WordcloudIcon,
  GuessTheNumberIcon,
  QuickFormIcon,
  ParagraphIcon,
  type IconProps,
} from '@mentimeter/ragnar-visuals/slide-type-icons';
import type { ModuleId } from '@mentimeter/http-clients';

const SLIDE_TYPE_ICON_MAP = {
  '100-points': PrioritisationIcon,
  big: BigIcon,
  bullets: BulletsIcon,
  choices: ChoicesIcon,
  deprecated: DeprecatedIcon,
  document: DocumentIcon,
  'free-text': FreeTextIcon,
  'google-slides': GoogleSlidesIcon,
  heading: HeadingIcon,
  image: ImageIcon,
  instructions: InstructionsIcon,
  metadata: QuickFormIcon,
  miro: MiroIcon,
  number: NumberIcon,
  'numerical-question': GuessTheNumberIcon,
  open: OpenEndedIcon,
  paragraph: ParagraphIcon,
  'pin-on-image': PinOnImageIcon,
  powerpoint: PowerpointIcon,
  qfa: QfaIcon,
  'quiz-choices': QuizChoicesIcon,
  'quiz-leaderboard': QuizLeaderboardIcon,
  'quiz-open': QuizOpenIcon,
  quote: QuoteIcon,
  ranking: RankingIcon,
  rating: RatingIcon,
  scales: ScalesIcon,
  video: VideoIcon,
  wordcloud: WordcloudIcon,
} satisfies Record<ModuleId, ComponentType<IconProps>>;

export const getSlideTypeIconFromModuleId = (
  moduleId: ModuleId,
): ComponentType<IconProps> | undefined => {
  return SLIDE_TYPE_ICON_MAP[moduleId];
};
